var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimitedRiskDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FEF3C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 16.0002C18.0003 17.1047 17.1049 18.0002 16.0003 18.0002C14.8958 18.0002 14.0003 17.1047 14.0003 16.0002C14.0003 14.8956 14.8958 14.0002 16.0003 14.0002C17.1049 14.0002 18.0003 14.8956 18.0003 16.0002Z",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63916 16.0001C10.4887 13.2954 13.0155 11.3335 16.0006 11.3335C18.9857 11.3335 21.5126 13.2954 22.3621 16.0002C21.5126 18.7049 18.9857 20.6668 16.0006 20.6668C13.0155 20.6668 10.4887 18.7049 9.63916 16.0001Z",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitedRiskDashboard);
export default __webpack_public_path__ + "static/media/limited-risk-dashboard.278a26eb9f098bfa44f2ac04be0ae671.svg";
export { ForwardRef as ReactComponent };